define('helperURL-parseModified',[],function() {
    'use strict';

    var parseModified = function(str) {
        var res = '',
            parse = function(str) {
                return str.replace(/[^\d]/g, '');
            };

        if (!str || typeof str !== 'string') {
            str = (new Date()).toJSON();
        }

        res = parse(str)

        return (res) ? res : parse((new Date()).toJSON());
    };

    return parseModified;
});

